import { registerDe } from '../i18n/index.js';

registerDe({
  'Admin': 'Verwaltung',
  'who may enter, who may call, what the record settled on, and the trail of every change':
    'wer eintreten darf, wer aufrufen darf, worauf sich der Datenbestand festgelegt hat, und die Spur jeder Änderung',
  'Operators': 'Operatoren',
  'accounts on the allowlist': 'Konten auf der Freigabeliste',
  'Registration': 'Registrierung',
  'allowlist or open': 'Freigabeliste oder offen',
  'Audit entries · 7d': 'Audit-Einträge · 7 T',
  'recorded mutations': 'aufgezeichnete Änderungen',
  'Settings': 'Einstellungen',
  'rows in app_settings': 'Zeilen in app_settings',
  'Refs minted': 'Vergebene Referenzen',
  'the counters and their next number': 'die Zähler und ihre nächste Nummer',
  // 'counting…', 'not collected' live in AgentsPage / common.
  '{allowlist} on the allowlist · {admins} admin': '{allowlist} auf der Freigabeliste · {admins} Admin',
  'allowlist': 'Freigabeliste',
  // 'the record did not answer' is PersonPage's; 'open' here is a context variant — the mode of the
  // door, feminine in French (inscription ouverte), not common's plain 'open'.
  'open\u2016registration': 'offen',
  'anyone who reaches the login may register': 'wer die Anmeldung erreicht, darf sich registrieren',
  'only listed e-mail addresses may log in': 'nur gelistete E-Mail-Adressen dürfen sich anmelden',
  'no mutation recorded in 7 days': 'keine Änderung in 7 Tagen aufgezeichnet',
  '{total} recorded mutations, all time': '{total} aufgezeichnete Änderungen, gesamt',
  'no ref minted yet': 'noch keine Referenz vergeben',
  '{kinds} counters · monotonic, never reused': '{kinds} Zähler · monoton, nie wiederverwendet',
  'What will fill the rest': 'Was den Rest füllen wird',
  'settings and the audit trail': 'Einstellungen und Audit-Spur',
  'The operator allowlist and the audit log already exist behind the auth and audit kits; this page counts them above and is where they will surface in full: the allowlist and its edits, the registration switch, the application settings with their history, the ref counters one by one, and the audit trail with its before/after diffs.':
    'Die Freigabeliste und das Audit-Log existieren bereits hinter dem Auth- und dem Audit-Kit; diese Seite zählt sie oben und wird sie vollständig sichtbar machen: die Freigabeliste und ihre Änderungen, den Registrierungsschalter, die Anwendungseinstellungen mit ihrer Historie, die Referenzzähler einzeln und die Audit-Spur mit ihren Vorher/Nachher-Vergleichen.',
}, 'AdminPage');
